import { Injectable } from '@angular/core';
import { RoomCategoryModel } from 'src/app/core/models/room-category.model';
import { HttpClient } from '@angular/common/http';
import { BaseService } from 'src/app/core/base/base.service';
import { AuthService } from '../../../../core/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class RoomCategoryService extends BaseService<RoomCategoryModel> {
  defaultSort = 'createdAt';

  constructor(
    public http: HttpClient,
    public authService: AuthService,
  ) {
    super(http, 'room-category', authService);
  }
}
